import { render, staticRenderFns } from "./LdbPaymentReferenceSearch.vue?vue&type=template&id=4856af27"
import script from "./LdbPaymentReferenceSearch.vue?vue&type=script&lang=js"
export * from "./LdbPaymentReferenceSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports